// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","449":"notFound","818":"auth","871":"legal"}[chunkId] + "." + {"443":"27bcffa9","449":"e52deeeb","818":"0a72464c","871":"0698ae51"}[chunkId] + ".js";
};